export default {
	players: [
		{
			name: 'ALICE',
			turn: false,
			alignment: { friend: '1', foe: '0' },
			revealed: { foe: true, friend: true },
			allowedToAccuse: { friend: true, foe: true },
		},
		{
			name: 'BOB',
			turn: true,
			alignment: { friend: '0', foe: '3' },
			revealed: { friend: true, foe: false },
			allowedToAccuse: { friend: true, foe: true },
		},
		{
			name: 'ALEX',
			turn: false,
			alignment: { friend: '1', foe: '3' },
			revealed: { foe: true, friend: true },
			allowedToAccuse: { friend: true, foe: true },
		},
		{
			name: 'AZYR',
			turn: true,
			alignment: { friend: '2', foe: '3' },
			revealed: { friend: false, foe: false },
			allowedToAccuse: { friend: true, foe: true },
		},
		{
			name: 'AZAZYRA',
			turn: false,
			alignment: { friend: '1', foe: '2' },
			revealed: { foe: true, friend: true },
			allowedToAccuse: { friend: true, foe: true },
		},
		{
			name: 'AZAROG',
			turn: true,
			alignment: { friend: '3', foe: '2' },
			revealed: { friend: false, foe: false },
			allowedToAccuse: { friend: true, foe: true },
		},
	],
	hasTurnEnded: false,
	pieces: [
		{
			id: '0-A1',
			position: [-1, -1],
			direction: [-1, 0],
			selectedDirection: [-1, 0],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '2-A1',
			moved: false,
		},
		{
			id: '0-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
		},
		{
			id: '0-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
		},
		{
			id: '0-A4',
			selected: true,
			killed: false,
			showMoveCells: true,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: true,
			position: [1, 1],
			direction: [0, 0],
			selectedDirection: [0, 0],
		},
		{
			id: '0-A5',
			position: [3, 3],
			direction: [1, 0],
			selectedDirection: [1, 0],
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
		},
		{
			id: '0-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
		},
		{
			id: '0-S',
			position: [-1, -1],
			direction: [1, 1],
			selectedDirection: [1, 1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '2-A1',
			moved: false,
		},
		{
			id: '0-N',
			position: [-1, -1],
			direction: [1, 0],
			selectedDirection: [1, 0],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '2-A1',
			moved: false,
		},
		{
			id: '1-A1',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A5',
			moved: false,
		},
		{
			id: '1-A2',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A5',
			moved: false,
		},
		{
			id: '1-A3',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A5',
			moved: false,
		},
		{
			id: '1-A4',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A5',
			moved: false,
		},
		{
			id: '1-A5',
			position: [3, 5],
			direction: [0, 0],
			selectedDirection: [0, 0],
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
		},
		{
			id: '1-C',
			position: [-1, -1],
			direction: [0, 0],
			selectedDirection: [0, 0],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A5',
			moved: false,
		},
		{
			id: '1-S',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A5',
			moved: false,
		},
		{
			id: '1-N',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A5',
			moved: false,
		},
		{
			id: '2-A1',
			position: [-1, -1],
			direction: [0, 1],
			selectedDirection: [0, 1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '1-A5',
			moved: false,
		},
		{
			id: '2-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
			position: [6, 2],
			direction: [1, 0],
			selectedDirection: [1, 0],
		},
		{
			id: '2-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
			position: [6, 0],
			direction: [1, 1],
			selectedDirection: [1, 1],
		},
		{
			id: '2-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
			position: [6, 1],
			direction: [0, 0],
			selectedDirection: [0, 0],
		},
		{
			id: '2-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
			position: [5, 0],
			direction: [1, 1],
			selectedDirection: [1, 1],
		},
		{
			id: '2-C',
			position: [1, 3],
			direction: [0, 0],
			selectedDirection: [0, 0],
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
		},
		{
			id: '2-S',
			position: [-1, -1],
			direction: [0, 0],
			selectedDirection: [0, 0],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '1-A5',
			moved: false,
		},
		{
			id: '2-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			moved: false,
			position: [5, 1],
			direction: [0, 0],
			selectedDirection: [0, 0],
		},
		{
			id: '3-A1',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
		{
			id: '3-A2',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
		{
			id: '3-A3',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
		{
			id: '3-A4',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
		{
			id: '3-A5',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
		{
			id: '3-C',
			position: [-1, -1],
			direction: [0, 0],
			selectedDirection: [0, 0],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
		{
			id: '3-S',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
		{
			id: '3-N',
			position: [-1, -1],
			selected: false,
			killed: true,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
			killedById: '0-A1',
			moved: false,
		},
	],
	pieceState: 'deselection',
	followMouse: false,
	snipe: false,
	snipeWindow: null,
	piecesPrevState: [
		{
			id: '0-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
	],
	teamControl: [
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
	],
};
